import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import { InfoTooltipOnClick, TooltipConstants } from '@Components/InfoTooltip';
import { Banner } from '@els/els-react--banner';
import Header from './Header';

import QueryRow from './QueryRow';
import AlertNameRow from './AlertNameRow';
import SendAlertsToRow from './SendAlertsToRow';
import FrequencyRow from './FrequencyRow';
import TriggerModeRow from './TriggerModeRow';
import BasicContent from './BasicContent';
import AdvancedContent from './AdvancedContent';
import PreFooter from './PreFooter';
import Footer from './Footer';

import './AlertCreateDialog.scss';

export default function AlertCreateDialog(props) {
  const { className, alertsInfo, basicContentAvailable, isMigrateMode } = props;

  return (
    <GeneralDialogLayout
      {...props}
      className={classnames([className, 'create-alert-dialog'])}
      contentClassName="create-alert-dialog-content-wrapper"
      headerClassName="create-alert-dialog-header"
      header={<Header {...props} />}
      footerClassName="create-alert-dialog-footer"
      footer={<Footer {...props} />}>
      <Banner type="warn" isVisible={isMigrateMode} className="u-els-margin-bottom-1x">
        Upon migration, the previous alert results (shown in the Results from: dropdown menu) will be lost. Please ensure to review the
        results before completing the migration process.
      </Banner>
      <QueryRow {...props} />
      {alertsInfo && (
        <>
          <AlertNameRow {...props} />
          <SendAlertsToRow {...props} />
          <FrequencyRow {...props} />
          <TriggerModeRow {...props} />
          {basicContentAvailable && <BasicContent {...props} />}
          <AdvancedContent {...props} />
          <PreFooter {...props} />
        </>
      )}
      <InfoTooltipOnClick id={TooltipConstants.ids.AlertCreateDialog} />
    </GeneralDialogLayout>
  );
}

AlertCreateDialog.propTypes = {
  className: PropTypes.string,
  alertsInfo: PropTypes.object,
  basicContentAvailable: PropTypes.bool,
};
